import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import s from './CTA.module.css';

gsap.registerPlugin(ScrollTrigger);

export default function CTA({ onShowPopup }) {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(contentRef.current.children, {
        y: 40,
        opacity: 0,
        duration: 1.2,
        stagger: 0.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <div className={s.wrapper}>
      <section className={s.ctaSection} ref={sectionRef}>
        {/* Effet Galaxie / Particules de fond */}
        <div className={s.starsContainer}>
          <div className={s.star}></div>
          <div className={s.star}></div>
          <div className={s.star}></div>
        </div>
        
        <div className={s.galaxyOrbs}>
          <div className={s.orb1}></div>
          <div className={s.orb2}></div>
        </div>

        <div className={s.container}>
          <div className={s.ctaContent} ref={contentRef}>
            <h2 className={s.ctaTitle}>
              Propulsez la gestion de vos troupeaux dans une nouvelle ère.
            </h2>
            <p className={s.ctaDescription}>
              Rejoignez les éleveurs qui utilisent l'intelligence artificielle pour sécuriser 
              et automatiser le comptage de leurs animaux.
            </p>
            <div className={s.btnWrapper}>
              <button className={s.ctaButton} onClick={onShowPopup}>
                Nous rejoindre
              </button>
            </div>
          </div>
        </div>
      </section>

      <footer className={s.footer}>
        <div className={s.footerMain}>
          
          <div className={s.brandSection}>
            <div className={s.logoWrapper}>
              <img src="/images/logo.png" alt="SefCheptel" className={s.brandLogo} />
              <span className={s.brandName}>SEF CHEPTEL</span>
            </div>
          </div>

          {/* DROITE : Navigation (avec auto-margin pour l'alignement) */}
          <div className={s.navSection}>
            <div className={s.upperRow}>
              <nav className={s.linksGrid}>
                <div className={s.linkColumn}>
                  <a href="#hero" className={s.footerLink}>Accueil</a>
                  <a href="#about" className={s.footerLink}>À propos</a>
                </div>
                <div className={s.linkColumn}>
                  <a href="#features" className={s.footerLink}>Fonctionnalités</a>
                  <a href="#benefits" className={s.footerLink}>Avantages</a>
                </div>
              </nav>

              <button className={s.contactBtn} onClick={onShowPopup}>
                Nous contacter
              </button>
            </div>

            <div className={s.footerBottomRight}>
              <div className={s.separatorLine}></div>
              <div className={s.credits}>
                <div>
                  <p className={s.copyright}>© 2026 SefCheptel.Tous droits réservés.</p>
                </div>
                <div className={s.luminiaCredit}>
                  <p className={s.poweredBy}>Powered by <span>Lumin'IA</span></p>
                  <span className={s.dot}></span>
                  <a href="mailto:luminia.madagascar@gmail.com" className={s.luminiaMail}>luminia.madagascar@gmail.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}